import styled from 'styled-components';

export const Note = styled.p`
  font-size: 0.9rem;
  margin: 1rem 0;
`;

export const MoreInfo = styled.div`
  margin-top: 1rem;
  font-size: 0.9rem;

  a {
    text-decoration: underline;

    :hover {
      text-decoration: none;
    }
  }
`;
